import { render } from "./configMonetaryCorrectionComponent.vue?vue&type=template&id=112ead49"
import script from "./configMonetaryCorrectionComponent.vue?vue&type=script&lang=js"
export * from "./configMonetaryCorrectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__